import {LeaveCategoriesList} from "./LeaveCategoriesList";
import {LeaveCategoriesEdit} from "./LeaveCategoriesEdit";
import {LeaveCategoriesCreate} from "./LeaveCategoriesCreate";

export default {
    list: LeaveCategoriesList,
    create: LeaveCategoriesCreate,
    edit: LeaveCategoriesEdit
};
